import * as ActionTypes from '@/store/mutations/nav/type'

export default {
  navDelete: ({ commit }, params) => {
    commit(ActionTypes.NAV_DELETE, params)
  },
  navChange: ({ commit }, params) => {
    commit(ActionTypes.NAV_CHANGE, params)
  },
  navAppend: ({ commit }, params) => {
    commit(ActionTypes.NAV_APPEND, params)
  },
  navPrependNameByPath: ({ commit }, params) => {
    commit(ActionTypes.NAV_PREPEND_NAME_BY_PATH, params)
  },
  navAppendAndClose: ({ commit }, params) => {
    commit(ActionTypes.NAV_APPEND_AND_CLOSE, params)
  },
  navBackChange: ({ commit }, params) => {
    commit(ActionTypes.NAV_BACK_CHANGE, params)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/nav/nav.js